import React from "react";
import ReactDOM from "react-dom/client";
//import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./App";
//import AppDebug from "./AppDebug";
import { ModalProvider } from "./context/ModalContext";
//import { AuthProvider } from "./context/AuthContext";
//import {  MessagesProvider } from "./context/MessagesContext";
//import ModalRoot from "./components/ModalRoot";

ReactDOM.createRoot(document.getElementById("root")).render(
  
  <React.StrictMode> 
{/* <MessagesProvider> 
    <AuthProvider>    */}
    <ModalProvider>
    
      {/* <AppDebug /> */}
      
      <App />
      
      {/* <ModalRoot /> */}
    
    </ModalProvider>
{/* </AuthProvider>
    </MessagesProvider>  */}
  </React.StrictMode>
);
